<template>
   
        <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previewmodal">
            <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
            <template v-else>
            <template v-if="pdfobject !==''">
                <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
            </template>
        </b-modal>
  
</template>

<script>

import axios from 'axios'
export default {
    name: 'ModalPreview',
    props: ['invoicePrev'],
    data: () => {
        return {
            previewmodal: false,
            cargandopdf2: false,
            pdfobject: '',
            invoicePrevLocal: {
                data: '',
                bandera: false
            }
        }
    },
    mounted() {
        this.prev()
    },
    methods: {
        prev: function () {
            this.invoicePrevLocal.data =  this.invoicePrev.data,
            this.invoicePrevLocal.bandera =  this.invoicePrev.bandera
            if(this.invoicePrevLocal.bandera){
                this.viewPdf(this.invoicePrevLocal.data)
            }else{
                this.previewmodal = false
            }
        },
        viewPdf: function (data) {
            this.previewmodal = true,
            this.pdfobject = '',
            this.cargandopdf2 = true
            axios
            .post(process.env.VUE_APP_API_URL + 'facturas/pdf',{
            token: this.$store.getters.userToken,
            id: data.idFactura
            })
            .then(response => (
                this.validPdf(response.data)
            ))
            .catch(error => {
                this.$snotify.error(error.response.data.message, 'Error'),
                this.previewmodal = false
                
            })
        },
        validPdf: function (data) {
            if(data.success==1){
                this.pdfobject = data.base64,
                this.cargandopdf2 = false,
                this.invoicePrevLocal = {
                        data: '',
                        bandera: false
                },
                this.$snotify.success(data.message, 'Exito')
            }else{
                this.previewmodal = false,
                this.$snotify.warning(data.message, 'Atención')
            }   
            
        }
    }
}
</script>
